"use client";

import { useAccordionContext } from "./context";

export default function Item({ children, className, id, ...props }) {
  const { activeItem } = useAccordionContext();

  return (
    <div
      aria-expanded={activeItem === id}
      {...props}
      className={className}
    >
      {children}
    </div>
  );
}
